import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchDepotLocation = async ({ locationName }) => {
  const queryParams = [];

  try {
    if (locationName) {
      queryParams.push(`locationName=${encodeURIComponent(locationName)}`);
    }
    const response = await axiosInstance.get(`/DepotLocation/search?${queryParams.join('&')}`);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw new Error('Error fetching depot location');
    }
  }
  return {};
};
const getDepotLocationById = async ({ DepotLocationID }) => {
  try {
    const response = await axiosInstance.get(`/DepotLocation/DepotLocationID/${DepotLocationID}`);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw new Error('Error fetching depot location by ID');
    }
  }
  return {};
};
const DepotLocationApi = {
  searchDepotLocation,
  getDepotLocationById,
};

export default DepotLocationApi;
